import React, { useState } from 'react';
import {
  Box,
  Tabs,
  Tab,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Paper,
  makeStyles
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SchoolIcon from '@material-ui/icons/School';
import PersonIcon from '@material-ui/icons/Person';
import GroupIcon from '@material-ui/icons/Group';
import InfoIcon from '@material-ui/icons/Info';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
    backgroundColor: '#f9fbfc',
    minHeight: '70vh',
  },
  heading: {
    fontWeight: 'bold',
    marginBottom: theme.spacing(3),
  },
  tabPaper: {
    marginBottom: theme.spacing(3),
    borderRadius: theme.spacing(1),
    overflow: 'hidden',
  },
  accordion: {
    boxShadow: 'none',
    borderBottom: '1px solid #ddd',
  },
}));

const faqData = {
  schools: [
    {
      question: "Q1. Is Montestory designed only for Montessori schools?",
      answer: "A: Yes, Montestory.in is exclusively developed based on authentic Montessori principles and classroom structure.",
    },
    {
      question: "Q2: How long does it take to set up the application for a new school?",
      answer: "A: Typically takes 1-3 working days – Onboarded  instantly, once registered, admin will activate your account after due diligence.",
    },
    {
      question: "Q3: Do we need any special hardware or software to use Montestory?",
      answer: "A: No, Montestory is a web-based application that works on desktops, laptops, tablets, and mobile devices with internet access.",
    },
    {
      question: "Q4: Is training provided for staff?",
      answer: "A: Yes, we offer guided onboarding sessions, video tutorials, and ongoing support to help your team make the most of Montestory.",
    },
  ],
  teachers: [
    {
      question: "Q1: Can I customize lesson plans according to my classroom needs?",
      answer: "A: No, While Montestory provides preloaded Montessori lesson plans, teachers can’t edit or add new ones.",
    },
    {
      question: "Q2: How are student activities and progress tracked?",
      answer: "A: Teachers can log daily activities, observations, assignments, and assessments, which are compiled into visual reports and analytics.",
    },
     {
      question: "Q3: Can I collaborate with co-teachers or assistants on the platform?",
      answer: "A: Yes, role-based access allows collaboration while keeping data secure and organized.",
    },
  ],
  parents: [
    {
      question: "Q1: Can parents see what their child is doing ?",
      answer: "A: Yes. The parent dashboard provides updates on activities, attendance, assignments, and upcoming events on a weekly basis",
    },
    {
      question: "Q2: Is my child’s data safe?",
      answer: "A: Yes. All data is encrypted and stored securely. We comply with international data protection standards.",
    },
  ],
  general: [
    {
      question: "Q1: What kind of support is available?",
      answer: "A: Our support team is available via chat, email, and phone during working hours. We also provide documentation and video guides.",
    },
    {
      question: "Q2: Is there a trial version?",
      answer: "A: Yes. Schools can try Montestory for free with limited access before deciding to subscribe.",
    },
  ],
};

const tabList = [
  { label: "For Schools", icon: <SchoolIcon />, key: "schools" },
  { label: "For Teachers", icon: <PersonIcon />, key: "teachers" },
  { label: "For Parents", icon: <GroupIcon />, key: "parents" },
  { label: "General", icon: <InfoIcon />, key: "general" },
];

export default function FAQComponent() {
  const classes = useStyles();
  const [selectedTab, setSelectedTab] = useState(0);
  const currentKey = tabList[selectedTab].key;

  return (
    <Box className={classes.root}>
      <Typography variant="h4" align="center" className={classes.heading}>
        Frequently Asked Questions
      </Typography>

      <Paper className={classes.tabPaper}>
        <Tabs
          value={selectedTab}
          onChange={(e, newVal) => setSelectedTab(newVal)}
          variant="scrollable"
          scrollButtons="auto"
          indicatorColor="primary"
          textColor="primary"
        >
          {tabList.map((tab, index) => (
            <Tab
              key={index}
              label={tab.label}
              icon={tab.icon}
              style={{
                textTransform: 'none',
                minWidth: 160,
                backgroundColor: selectedTab === index ? '#e3f2fd' : 'inherit',
              }}
            />
          ))}
        </Tabs>
      </Paper>

      {faqData[currentKey].map((faq, index) => (
        <Accordion key={index} className={classes.accordion}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>{faq.question}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography color="textSecondary">{faq.answer}</Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
}
